import CampaignList from "./CampaignList";

const Campaign = () => {
  return (
    <CampaignList />
  );
};

export default Campaign;
